var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgThreeCoins(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 36 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    cx: "78.767%",
    cy: "50%",
    fx: "78.767%",
    fy: "50%",
    r: "50%",
    id: "threeCoins_svg__a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8DB05",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEB502",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)",
    fill: "url(#threeCoins_svg__a)",
    stroke: "#2E2E32",
    strokeWidth: 2,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10.887,
    cy: 10.887,
    r: 10.887
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.83,
    cy: 10.887,
    r: 10.887
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.83,
    cy: 10.887,
    r: 10.887
  }))));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzZweCIgaGVpZ2h0PSIyNHB4IiB2aWV3Qm94PSIwIDAgMzYgMjQiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8ZGVmcz4KICAgICAgICA8cmFkaWFsR3JhZGllbnQgY3g9Ijc4Ljc2NjkxMzklIiBjeT0iNTAlIiBmeD0iNzguNzY2OTEzOSUiIGZ5PSI1MCUiIHI9IjUwJSIgaWQ9InJhZGlhbEdyYWRpZW50LTEiPgogICAgICAgICAgICA8c3RvcCBzdG9wLWNvbG9yPSIjRjhEQjA1IiBvZmZzZXQ9IjAlIj48L3N0b3A+CiAgICAgICAgICAgIDxzdG9wIHN0b3AtY29sb3I9IiNFRUI1MDIiIG9mZnNldD0iMTAwJSI+PC9zdG9wPgogICAgICAgIDwvcmFkaWFsR3JhZGllbnQ+CiAgICA8L2RlZnM+CiAgICA8ZyBpZD0iU3ltYm9scyIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgaWQ9IkhlYWRlci9NZWRpdW0vTm8tQnV0dG9uLSstTm8tQmFkZ2VzIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtODMyLjAwMDAwMCwgLTI5LjAwMDAwMCkiIGZpbGw9InVybCgjcmFkaWFsR3JhZGllbnQtMSkiIHN0cm9rZT0iIzJFMkUzMiIgc3Ryb2tlLXdpZHRoPSIyIj4KICAgICAgICAgICAgPGcgaWQ9Ikdyb3VwIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg3MTYuMDAwMDAwLCAyMC4wMDAwMDApIj4KICAgICAgICAgICAgICAgIDxnIGlkPSJHQS1Db2lucyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMC4wMDAwMDAsIDguMDAwMDAwKSI+CiAgICAgICAgICAgICAgICAgICAgPGcgaWQ9Ikdyb3VwLTIiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDExNy4wMDAwMDAsIDIuMDAwMDAwKSI+CiAgICAgICAgICAgICAgICAgICAgICAgIDxjaXJjbGUgaWQ9Ik92YWwiIGN4PSIxMC44ODcwOTY4IiBjeT0iMTAuODg3MDk2OCIgcj0iMTAuODg3MDk2OCI+PC9jaXJjbGU+CiAgICAgICAgICAgICAgICAgICAgICAgIDxjaXJjbGUgaWQ9Ik92YWwiIGN4PSIxNS44Mjk1Mzk0IiBjeT0iMTAuODg3MDk2OCIgcj0iMTAuODg3MDk2OCI+PC9jaXJjbGU+CiAgICAgICAgICAgICAgICAgICAgICAgIDxjaXJjbGUgaWQ9Ik92YWwiIGN4PSIyMi44Mjk1Mzk0IiBjeT0iMTAuODg3MDk2OCIgcj0iMTAuODg3MDk2OCI+PC9jaXJjbGU+CiAgICAgICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4K";
export { SvgThreeCoins as ReactComponent };